var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{ref:"first",staticClass:"card-loader"}),_c('div',{ref:"second",staticClass:"card-loader"}),_c('div',{ref:"third",staticClass:"card-loader"}),_c('div',{ref:"fourth",staticClass:"card-loader"}),_c('div',{ref:"fifth",staticClass:"card-loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }